import { Flex, Heading, Spacer } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { ImplementationDetails } from './ImplementationDetails';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { BackButton } from '~/packages/common-frontend/components/BackButton';

// Types
const RouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing implementationId' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { implementationId } = RouteParamsStruct.parse(params);

  return (
    <>
      <Flex>
        <Heading mb="24px">Implementations</Heading>
        <Spacer />
        <BackButton />
      </Flex>
      <ImplementationDetails implementationId={implementationId} />
    </>
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
